import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';

import Card from '@components/layout/card';
import { type FormConfig, LitheForm } from '@components/form';

import { createId } from '@utils/index';

const FormsExample: LitheFC = ({
  id = createId(),
}): LitheElement<'section'> => {
  const onSubmit = (data: Record<string, string>) => {
    console.log('form: submit', data);
  };

  const config = {
    id: 'form-example',
    controls: [
      {
        id: 'name',
        element: 'input',
        label: 'Name',
        value: '',
        valid: false,
        touched: false,
        validations: { required: true },
        errorMessage: 'This field is required',
        config: {},
        classes: 'col-span-1 md:col-span-6',
      },
      {
        id: 'surname',
        element: 'input',
        label: 'Surname',
        value: '',
        valid: false,
        touched: false,
        validations: { required: true },
        errorMessage: 'This field is required',
        config: {},
        classes: 'col-span-1 md:col-span-6',
      },
      {
        id: 'comment',
        element: 'textarea',
        label: 'Comment',
        value: '',
        valid: false,
        touched: false,
        validations: { required: true },
        errorMessage: 'This field is required',
        config: { rows: '5' },
        classes: 'col-span-12',
      },
    ],
    buttons: [
      [
        'button',
        {
          type: 'submit',
          class: 'bg-primary text-white px-4 py-2 rounded hover:bg-opacity-90',
        },
        'submit',
      ],
    ],
    classes: { form: 'grid grid-cols-12 gap-4' },
    onSubmit,
  } satisfies FormConfig;

  return [
    'section',
    { id, class: 'col-span-12' },
    Card(
      { classes: 'p-6' },
      ['h2', { class: 'text-2xl text-primary mb-4' }, 'Forms with LitheJS'],
      [
        'p',
        { class: 'text-text mb-6' },
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      ],
      LitheForm(config)
    ),
  ];
};

export default FormsExample;
